import MyConfig from './MyConfig'

export default MyConfig
